module.exports = __webpack_public_path__ + "img/logo2.cf449ad9.png";